export const getToken = () => localStorage.getItem("token");
